import { createUseStyles } from 'react-jss';

const totalWidth = (base) => base * 5.75;
const circleWidth = (base) => base * 3.5;

const useStyle = createUseStyles((theme) => ({
  switch: (props) => ({
    display: 'inline-block',
    width: `${totalWidth(theme.sizes.base)}px`,
    height: `${theme.sizes.base * 3.75}px`,
    position: 'relative',
    border: 'solid 1px',
    borderRadius: `${theme.sizes.base * 12.5}px`,
    cursor: 'pointer',
    verticalAlign: 'middle',
    '&[disabled]': {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    '& > .circle': {
      position: 'absolute',
      top: 0,
      borderRadius: `${theme.sizes.base * 12.5}px`,
      width: `${circleWidth(theme.sizes.base)}px`,
      height: `${circleWidth(theme.sizes.base)}px`,
      backgroundColor: theme.colors.background.normal,
      border: 'solid 1px',
      transitionDuration: `${theme.speed.normal * 0.8}ms`,
      transitionTimingFunction: 'cubic-bezier(.25,.46,.45,.94)',
      transitionProperty: 'transform',
      willChange: 'transform',
      backfaceVisibility: 'hidden',
      [theme.direction.start]: '0',
      textAlign: 'center',
      overflow: 'hidden',
      '& > svg': {
        marginTop: '1px',
      },
    },
    '&.on': {
      backgroundColor: theme.colors[props._color].normal,
      color: theme.colors[props._color].normal,
      fill: theme.colors[props._color].normal,
      '& > .circle': {
        transform: `translateX(${theme.direction.transformFactor * (totalWidth(theme.sizes.base) - circleWidth(theme.sizes.base) - 2)}px)`,
      },
    },
    '&.off': {
      backgroundColor: theme.colors.background.contrast(10),
      color: theme.colors.background.contrast(20),
      fill: theme.colors.background.contrast(20),
      '& > .circle': {
        transform: 'translateX(0px)',
      },
    },
  }),
}));

export default useStyle;
